import PatientForm from './PatientForm';
import { getAuthToken } from '../../../util/auth';
import { redirect } from 'react-router-dom';
import { getApiChara } from '../../../util/getApi';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import { FaUserPlus } from 'react-icons/fa';

const NewPatient = () => {
    const { t } = useTranslation();
    return (
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <h3 className='textHead' style={{ color: 'var(--primary-color)', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>
                <FaUserPlus className="me-2" /> {t("Register Patient")}
            </h3>
            <PatientForm />
        </div>
    );
}

export default NewPatient;

export async function action({ request, params }) {
    const data = await request.formData();
    const method = request.method;
    const patientData = {
        firstName: data.get('firstName'),
        middleName: data.get('middleName'),
        lastName: data.get('lastName'),
        nickName: data.get('nickName'),
        dob: data.get('dob'),
        maritalStatus: data.get('maritalStatus'),
        religion: data.get('religion'),
        caste: data.get('caste'),
        panCardNo: data.get('panCardNo'),
        adharCardNo: data.get('adharCardNo'),
        gender: data.get('gender'),
        age: data.get('age'),
        occupation: data.get('occupation'),
        identificationMark: data.get('identificationMark'),
        emailId: data.get('emailId'),
        mobile: data.get('mobile'),
        alternateMobileNum: data.get('alternateMobileNum'),
        address: data.get('address'),
        city: data.get('city'),
        pincode: data.get('pincode'),
        referredBy: data.get('referredBy'),
        registrationNo: data.get('registrationNo'),
    }

    const token = getAuthToken();
    if (token === null || token === 'EXPIRED') {
        return redirect('/');
    }
    const apiChar = getApiChara();
    const apiUrl = `${apiChar}/patient/addPatient`;

    try {
        const response = await fetch(apiUrl, {
            method: method,
            body: JSON.stringify(patientData),
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + token
            }
        });

        let responseBody = await response.json(); // Read the response body once and store it in a variable

        const errorMsg = responseBody.errorMsg;
        if (errorMsg !== null) {
            toast.error("Patient Already Exists");
            responseBody.errorMsg = "Patient Already Exists";
            toast.success("Patient added successfully!");
            return responseBody;
        } else if (!response.ok) {
            toast.error("Could not save Patient");
            throw new Error({ message: 'Could not save Patient.', status: 500 });
        }

        // Use responseBody for further operations if needed
        return redirect('..');
    } catch (error) {
        console.log(error) // Rethrow the error to handle it in the calling code
    }
}
